import { render } from "./StafetDeltagPaaHoldFlow.vue?vue&type=template&id=9ccc76d2"
import script from "./StafetDeltagPaaHoldFlow.vue?vue&type=script&lang=js"
export * from "./StafetDeltagPaaHoldFlow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__